import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import StudentRequisition from './StudentRequisition'

export const UserRequisition = () => {
  return (
    <>
        <RoutingMenu activeScreen="UserRequisition" />
            <div className=''>
                {/* <iframe
                    src={`${config.RootUrl}/faculty/library/Requisition/Requisition.php?isIframe=true`}
                    className="iframe col-md-12" >
                </iframe> */}

                {
                  config.account == "faculty" ?
                    <iframe
                      src={`${config.RootUrl}/faculty/library/Requisition/Requisition.php?isIframe=true`}
                      className="iframe col-md-12" >
                    </iframe>
                    :
                    <StudentRequisition />
                    // <iframe
                    //   src={`${config.RootUrl}/student/library/view/requisition/requisition.php?isIframe=true`}
                    //   className="iframe col-md-12" >
                    // </iframe>
                }
                
            </div>
    </>
  )
}
